import { useContractCall } from "@usedapp/core";

export const useAllowance = (address, abi, account) => {
  const [allowance] = useContractCall({
    abi: abi,
    address: address,
    method: 'allowanceOf',
    args: [account],
  }) ?? []
  if (allowance) {
    return allowance.toNumber();
  }
  return 0;
}